import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { CommonRegEx } from '@nrwl/common-lib';

import {
  IComponentStateHistory,
  IValueChangedEvent,
  IWizardContentComponent
} from '../../../wizard.content';
import { IPAMConfigWizardService } from '../../../services/ipam/ipam.configuration.wizard.service';

@Component({
  selector: 'ipam-configuration-html',
  templateUrl: './ipam.configuration.template.html',
  styleUrls: ['../ipam.configuration.style.scss']
})
export class IPAMConfigurationComponent implements IWizardContentComponent, OnInit {
  @Input() step: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() subStep: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() wizardCtrl: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() componentId: string;
  @Input() stateHistory?: IComponentStateHistory;
  @Input() previousOutput: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onDataValueChange = new EventEmitter<IValueChangedEvent>();
  @ViewChild('currentForm', { static: true }) form: NgForm;

  validAddressRegex: RegExp = CommonRegEx.URL_WITH_APPROVED_PROTO_REGEX;
  isValidMsg = true;
  url: string;
  username: string;
  password: string;
  params: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  hide = true;

  constructor(private wizardService: IPAMConfigWizardService) {}

  ngOnInit() {
    this.step.form = this.form;
    this.params = [];
  }

  urlUpdated(): void {
    let isValidUrl = this.validAddressRegex.test(this.url);
    this.isValidMsg = isValidUrl;
    if (this.url == '') {
      isValidUrl = false;
      this.isValidMsg = true;
    }
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'urlInput',
      key: 'url',
      newValue: this.url,
      isValid: isValidUrl
    });
  }

  usernameUpdated(): void {
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'usernameInput',
      key: 'username',
      newValue: this.username,
      isValid: this.username !== '' ? true : false
    });
  }

  passwordUpdated(): void {
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'passwordInput',
      key: 'password',
      newValue: this.password,
      isValid: this.password !== '' ? true : false
    });
  }
}
